export const PERMISSIONS = {
	additionalAdminAccess: "AdditionalAdminAccess",
	additionalCmtAccess: "AdditionalCmtAccess",
	defaultAccess: "DefaultAccess",
	additionalGopAccess: "AdditionalGopAccess",
}

export const REGIONS = [
	{
		id: 1,
		key: 'EUROPE',
		name: 'Europe',
	},
	{
		id: 2,
		key: 'NORTH_AMERICA',
		name: 'North America',
	},
	{
		id: 3,
		key: "APAC",
		name: 'APAC',
	},
	{
		id: 4,
		key: "MIDDLE_EAST_AFRICA",
		name: "Middle East & Africa"
	},
	{
		id: 5,
		key: "NA",
		name: 'N/A',
	},
	{
		id: 6,
		key: "GLOBAL",
		name: 'Global',
	}
]

export const SURVEY_QUESTION_TYPES = {
	TEXT: "TEXT",
	SINGLE: "SINGLE",
	MULTIPLE: "MULTIPLE",
}

export const PAGE_NAME = {
    home: "home",
    login: "login",
    submission: "submission",
    management: "management",
    projectSteps: {
			dashboard: `dashboard`,
			draft: {
				name: "DRAFT",
				label: "Draft",
				slug: 'draft',
        id: 0,
				nextStep: {
					label: 'projectFroms.newSubmission',
					name: 'NEW_SUBMISSION'
				}
			},
			"new-submissions": {
				name: "NEW_SUBMISSION",
				label: "New Submissions",
				slug: 'new-submissions',
				id: 1,
				nextStep: {
					label: 'projectFroms.assigned',
					name: 'ASSIGNED'
				}
			},
			assigned: {
				name: "ASSIGNED",
				label: "Assigned",
				slug: 'assigned',
        id: 2,
				nextStep: {
					label: 'projectFroms.startReview',
					name: 'UNDER_REVIEW'
				}
      },
			"under-review": {
				name: "UNDER_REVIEW",
				label: "Under Review",
				slug: "under-review",
				id: 3,
				nextStep: {
					label: 'projectFroms.finishReview',
					name: 'CM_VALIDATION'
				}
      },
			"cm-validation": {
				name: "CM_VALIDATION",
				label: "Content Manager Validation",
				slug: "cm-validation",
        id: 4,
				nextStep: {
					label: 'projectFroms.validate',
					name: 'RO_APPROVAL'
				}
      },
			"reference-owner-approval": {
				name: "RO_APPROVAL",
        label: "Reference Owner Approval",
				slug: "reference-owner-approval",
        id: 5,
				nextStep: {
					label: 'projectFroms.approved',
					name: 'APPROVED'
				}
      },
			"final-review": {
				name: "FINAL_REVIEW",
        label: "Final Review",
				slug: 'final-review',
        id: 6,
				nextStep: {
					label: '',
					name: ''
				}
      },
			"approved": {
				name: "APPROVED",
        label: "Ready To Publish",
				slug: 'approved',
        id: 7,
				nextStep: {
					label: 'projectFroms.publish',
					name: 'PUBLISHED'
				}
      },
			published: {
				name: "PUBLISHED",
				label: "Published",
				slug: 'published',
        id: 8,
				nextStep: {
					label: '',
					name: ''
				}
      },
    },
    projects: "projects",
    manage: "manage",
    content: "content",
    casesMain: "m",
    myProjects: "my-stories",
    casesSearchResult: "result",
    singleCS: "singleCase",
    singleCSWithDates: "singleCaseWithDates",
    casesByIndustries: "by-industry",
    industries: "industries",
    industry: "industry",
    services: "services",
    service: "service",
    technologies: "practices",
    user: "user",
    technology: "practice",
    email: "email",
    emailHistory: "emailH",
    saved: "saved",
    own: "own",
    new: "new",
    main: "m",
    single: "s",
    aboutUs: "about-us",
    notFound: "404",
    referencePreview: "reference-preview",
    draftReferencePreview: "draft-reference-preview",
    referenceOwnerPreview: "reference-owner-preview",
    editLanguage: "edit-language",
    update: "form",
    mode: "mode",
    search: "search"
};

export const LANGUAGE = {
	en: {
		name: "English",
		short: "EN",
		id: 1
	},
	de: {
		name: "Deutsch",
		short: "DE",
		id: 2
	},
	fr: {
		name: "Français",
		short: "FR",
		id: 3
	},
	it: {
		name: "Italiano",
		short: "IT",
		id: 4
	},
	ja: {
		name: "日本語",
		short: "JA",
		id: 5
	},
	es:{
		name: "Español",
		short: "ES",
		id: 6
	},
};

export const OFFER_TYPES_ENUM = {
	GLOBAL: "GLOBAL",
	LOCALIZED: "LOCALIZED",
	LOCAL: "LOCAL"
}
export const OFFER_TYPES = [
	{
		name: OFFER_TYPES_ENUM.GLOBAL,
		id: 1
	},
	{
		name: OFFER_TYPES_ENUM.LOCALIZED,
		id: 2
	},
	{
		name: OFFER_TYPES_ENUM.LOCAL,
		id: 3
	}
]

export const SECTOR_TYPES_ENUM = {
	GLOBAL: "GLOBAL",
	LOCALIZED: "LOCALIZED",
	LOCAL: "LOCAL"
}
export const SECTOR_TYPES = [
	{
		name: SECTOR_TYPES_ENUM.GLOBAL,
		id: 1
	},
	{
		name: SECTOR_TYPES_ENUM.LOCALIZED,
		id: 2
	},
	{
		name: SECTOR_TYPES_ENUM.LOCAL,
		id: 3
	}
]

export const LANGUAGE_ARRAY = [
    {
        name: "English",
        short: "EN",
				lowerCase: "en",
				id: 1
    },
    {
        name: "Deutsch",
        short: "DE",
				lowerCase: "de",
				id: 2
    },
    {
        name: "Français",
        short: "FR",
				lowerCase: "fr",
				id: 3
    },
    {
        name: "Italiano",
        short: "IT",
				lowerCase: "it",
				id: 4
    },
    {
        name: "日本語",
        short: "JA",
				lowerCase: "ja",
				id: 5
    },
		{
				name: "Español",
				short: "ES",
				lowerCase: "es",
				id: 6
		},
];

export const LOCAL_CONSTS = {
    version: "drc_local_version",
    vuex: "vuex",
};

export const PROJECT_STEPS = {
    draft: 0,
    newReference: 1,
    assigned: 2,
    underReview: 3,
    cmValidation: 4,
    roApproval: 5,
    readyToPublish: 7,
    published: 8,
}

export const PROJECT_STEP_IDS = {
	0: "DRAFT",
	1: "NEW_SUBMISSION",
	2: "ASSIGNED",
	3: "UNDER_REVIEW",
	4: "CM_VALIDATION",
	5: "RO_APPROVAL",
	7: "APPROVED",
	8: "PUBLISHED"
}

export const PROJECT_STEPS_UPPERCASE = {
	DRAFT: 0,
	NEW_SUBMISSION: 1,
	ASSIGNED: 2,
	UNDER_REVIEW: 3,
	CM_VALIDATION: 4,
	RO_APPROVAL: 5,
	APPROVED: 7,
	PUBLISHED: 8
}

export const PAGE_STEPS = {
    "draft": 0,
    "new-submissions": 1,
    "assigned": 2,
    "under-review": 3,
    "cm-validation": 4,
    "reference-owner-approval": 5,
    "final-review": 6,
    "ready-to-publish": 7,
    "published": 8,
    "archived": 10
}

export const NOTIFICATION_TYPE = {
    "SUCCESS": "success",
    "ERROR": "error",
    "WARNING": "warning",
    "INFO": "info"
}

export const SERVICE_LINE = {
    akkodisReasearchBEId: 10
}

export const RESPONSE_STATUS = {
    skipErrors: [401, 403, 404]
}
export const ATTRIBUTE_TYPE = {
    certification: "CERTIFICATION",
    tool: "TOOL"
}

export const SUBMISSION_STEP_FORM = {
    languageSelect: 0,
    aboutTheClient: 1,
    clientContext: 2,
    akkodisSolutions: 3,
    supportingInformation: 4,
    results: 5,
    clientTestimonials: 6,
    akkodisExpoertise: 7,
    akkodisTeam: 8,
    projectgallery: 9
};

export const ATTRIBUTE_STATUS = {
    APPROVED: "APPROVED",
    FOR_APPROVAL: "FOR_APPROVAL",
    INACTIVE: "INACTIVE"
}

export const DRAFT_STORE_BLUEPRINT = {
    id: null,
    sourceLanguage: "",
    currentStep: 0,
    progressionStep: 0,
    customerName: "",
    industry: null,
    subIndustry: null,
    logo: {
        id: null,
        objectKey: null,
        objectUrl: null
    },
    mainImage: {
        id: null,
        objectKey: null,
        objectUrl: null
    },
    confidentiality: {},
    isNewBusiness: false,
    clientCountries: [],
    isProjectOngoing: false,
    dateFromYear: null,
    dateFromMonth: null,
    dateToYear: null,
    dateToMonth: null,
    businessLines: [],
    modisOfferings: [],
    fte: {
        id: null,
        label: null
    },
    revenue: {
        id: null,
        label: null
    },
    tools: [],
    certification: [],
    modisCountries: [],
    aboutTheClient: "",
    akkodisResult: "",
    clientResult: "",
    solution: "",
    akkodisChallenge: "",
    clientContext: "",
    testimonials: [
        {
            name: "",
            jobRole: "",
            customerQuote: "",
        }
    ],
    deliveryContactManager: {
        email: "",
        fullName: ""
    },
    businessContactManager: {
        email: "",
        fullName: ""
    },
    links: [],
    createdBy: "",
    gallery: [],
    galleryNew: [],
    stepStatus: true,
}

export const MANAGEMENT_STORE_BLUEPRINT = {
    id: null,
    sourceLanguage: "EN",
    industry: null,
    subIndustry: null,
    customerName: "",
    logo: {
        id: null,
        objectKey: null,
        objectUrl: null
    },
    mainImage: {
        id: null,
        objectKey: null,
        objectUrl: null
    },
    confidentiality: {},
    isNewBusiness: false,
    clientCountries: [],
    isProjectOngoing: false,
    dateFromYear: null,
    dateFromMonth: null,
    dateToYear: null,
    dateToMonth: null,
    businessLines: [],
    modisOfferings: [],
    fte: {
        id: null,
        label: null
    },
    revenue: {
        id: null,
        label: null
    },
    tools: [],
    certification: [],
    modisCountries: [],
    referenceTitle: "",
    aboutTheClient: "",
    akkodisResult: "",
    clientResult: "",
    solution: "",
    akkodisChallenge: "",
    clientContext: "",
    testimonials: [
        {
            name: "",
            jobRole: "",
            customerQuote: "",
        }
    ],
    deliveryContactManager: {},
    businessContactManager: {},
    links: [{
        keyword: '',
        url: ''
    }],
    gallery: [],
    galleryNew: [],
    authorName: "",
    authorEmail: "",
    formStatus: true,
    CMTformInitState: ""
}

export const IMAGE_TYPE = {
    main: "MAIN",
    logo: "LOGO",
    other: "OTHER"
}

export const PLATFORMS = {
	DRC: "DRC",
	GOP: "GOP"
}

export const API_HEADER = {
	authorization: "Authorization",
	jwt: 'jwt'
};

export const PREVIEW_MODES = {
	draftPreview: "draft-reference-preview",
	referencePreview: "reference-preview",
	ownerPreview: "reference-owner-preview"
};

export const METHOD_TYPE = {
	'POST': 'POST',
	'GET': 'GET'
}

export const GRAPHQL_ENDPOINT = `${process.env.VUE_APP_BACKEND_API_URL}/graphql`;

export const OFFER_COUNTRY_TYPE = {
	"DELIVERY_LOCATION": "DELIVERY_LOCATION",
	"FASTEST_GROWING_MARKET": "FASTEST_GROWING_MARKET",
	"LARGEST_MARKET": "LARGEST_MARKET"
}

export const GOP_IMAGE_TYPE = {
	PANORAMIC: "PANORAMIC",
	THUMBNAIL: "THUMBNAIL",
	MOBILE_PANORAMIC: "MOBILE_PANORAMIC"
}

export const GOP_FILE_TYPE = {
	PPT: "PPT",
	PDF: "PDF"
}

export const FORMAT = {
	'GRID': 'GRID',
	'LIST': 'LIST'
}

export const ANNUAL_REVENUES = [
	{name: '< 1 mln EUR', id: 1, key: 'RANGE_0_1MLN_EUR'},
	{name: '1 mln - 5 mln EUR', id: 2, key: 'RANGE_1_5MLN_EUR'},
	{name: '5 mln - 10 mln EUR', id: 3, key: 'RANGE_5_10MLN_EUR'},
	{name: '10 mln - 50 mln EUR', id: 4, key: 'RANGE_10_50MLN_EUR'},
	{name: '50 mln - 100 mln EUR', id: 5, key: 'RANGE_50_100MLN_EUR'},
	{name: '> 100 mln EUR', id: 6, key: 'ABOVE_100MLN_EUR'},
	{name: 'N/A', id:1, key: 'N_A'},
]

export const MATURITIES = [
	{name: 'Empty', id: 1, key: 'EMPTY'},
	{name: 'Ready to Sell', id: 2, key: 'READY_TO_SELL'},
	{name: 'Ready to Deliver', id: 3, key: 'READY_TO_DELIVER'},
]

export const RECOGNITION_TYPES_ENUM = {
	GLOBAL: "GLOBAL",
	LOCALIZED: "LOCALIZED",
	LOCAL: "LOCAL"
}
export const RECOGNITION_TYPES = [
	{
		name: RECOGNITION_TYPES_ENUM.GLOBAL,
		id: 1
	},
	{
		name: RECOGNITION_TYPES_ENUM.LOCALIZED,
		id: 2
	},
	{
		name: RECOGNITION_TYPES_ENUM.LOCAL,
		id: 3
	}
]
